module.exports = global["$"] = require("-!/data/www/mathesio/html/webapp/node_modules/imports-loader/index.js?global=>window,this=>window!./singleton.js");


//////////////////
// WEBPACK FOOTER
// ../~/expose-loader?$!../~/imports-loader?global=>window,this=>window!../~/raven-js/src/singleton.js
// module id = 351
// module chunks = 0